export default __webpack_public_path__ + "static/media/search2.d040564f.svg";